export default __webpack_public_path__ + "static/sesame2-a-4b37277ba5af4a725f82763d4ff9e9af.webp";